<template>
	<div class="settings-shell container py-3 pb-5">
		<JuniperPageHeader back="/" title="Settings" subtitle="Configure MC2 application settings and integrations" />

		<ul class="nav nav-tabs mt-3" role="tablist">
			<li class="nav-item" role="presentation" v-if="authUser.permissions.includes('SETTINGS_GENERAL_ACCESS')">
				<router-link class="nav-link" :class="{ active: $route.name === 'settingsGeneral' }" to="/settings">
					<i class="fas fa-cog me-1"></i> General
				</router-link>
			</li>
			<li class="nav-item" role="presentation" v-if="authUser.permissions.includes('ROLE_ACCESS')">
				<router-link class="nav-link" :class="{ active: $route.name === 'settingsRoles' }" to="/settings/roles">
					<i class="fas fa-user-shield me-1"></i> Roles &amp; Permissions
				</router-link>
			</li>
			<li
				class="nav-item"
				role="presentation"
				v-if="authUser.permissions.includes('CAMPAIGN_ACCESS') || authUser.permissions.includes('SETTINGS_GENERAL_ACCESS')"
			>
				<router-link class="nav-link" :class="{ active: $route.name === 'settingsIntegrations' }" to="/settings/integrations">
					<i class="fas fa-puzzle-piece me-1"></i> Integrations
				</router-link>
			</li>
			<li class="nav-item" role="presentation" v-if="authUser.permissions.includes('CAMPAIGN_ACCESS')">
				<router-link class="nav-link" :class="{ active: $route.name === 'settingsHooks' }" to="/settings/hooks">
					<i class="fas fa-bolt me-1"></i> Hooks
				</router-link>
			</li>
			<li class="nav-item" role="presentation" v-if="authUser.permissions.includes('SETTINGS_GENERAL_ACCESS')">
				<router-link class="nav-link" :class="{ active: $route.name === 'settingsShortlinks' }" to="/settings/short-links">
					<i class="fas fa-link me-1"></i> Short Links
				</router-link>
			</li>
			<li class="nav-item" role="presentation" v-if="authUser.permissions.includes('SETTINGS_GENERAL_ACCESS')">
				<router-link class="nav-link" :class="{ active: $route.name === 'settingsPricingEngine' }" to="/settings/pricing-engine">
					<i class="fas fa-tags me-1"></i> Pricing Engine
				</router-link>
			</li>
			<li class="nav-item" role="presentation" v-if="authUser.permissions.includes('SETTINGS_GENERAL_ACCESS')">
				<router-link class="nav-link" :class="{ active: $route.name === 'settingsModules' }" to="/settings/modules">
					<i class="fas fa-layer-group me-1"></i> Modules
				</router-link>
			</li>
			<li class="nav-item" role="presentation" v-if="authUser.permissions.includes('SETTINGS_GENERAL_ACCESS')">
				<router-link class="nav-link" :class="{ active: $route.name === 'settingsAudits' }" to="/settings/audits">
					<i class="fas fa-universal-access me-1"></i> Audits
				</router-link>
			</li>
		</ul>

		<div class="js-tab-content">
			<router-view></router-view>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import JuniperPageHeader from '@/components/juniper/layout/JuniperPageHeader.vue'

export default {
	name: 'SettingsParent',
	computed: {
		...mapState(['authUser']),
	},
	components: {
		JuniperPageHeader,
	},
}
</script>

<style lang="scss">
/* Not scoped on purpose — the shell styles must reach the router-view
   children. Everything inside the partial is namespaced under
   .settings-shell, so nothing leaks outside this page. */
@import '@/assets/sass/settings-shell';
</style>
